import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import {
  IInvoice,
  IWorkLog,
  WorkLogStatus
} from "@wingspanhq/payments/dist/interfaces";

type GetWorkLogStatusCellPropsParams = {
  workLog: IWorkLog;
  invoice?: IInvoice;
};

export function getWorkLogPayeeStatusCellProps({
  workLog,
  invoice
}: GetWorkLogStatusCellPropsParams): WSTableCellProps {
  switch (workLog.status) {
    case WorkLogStatus.Approved:
      return {
        secondaryText: invoice?.invoiceNumber
          ? `Invoiced #${invoice.invoiceNumber}`
          : undefined,
        pill: {
          text: "Approved",
          theme: "success",
          icon: "check-circle"
        }
      };

    case "InProgress" as WorkLogStatus:
      return {
        secondaryText: "Returned for editing",
        secondaryTextColor: "amber400",
        pill: {
          text: "Action required",
          theme: "warning",
          icon: "alert-circle"
        }
      };

    case "InReview" as WorkLogStatus:
      return {
        secondaryText: "Awaiting client approval",
        pill: {
          text: "Submitted",
          theme: "blue",
          icon: "time"
        }
      };

    case "Rejected" as WorkLogStatus:
      return {
        secondaryText: workLog.invoiceId ? "Cancelled invoice" : "Not invoiced",
        pill: {
          text: "Rejected",
          theme: "error",
          icon: "alert-circle"
        }
      };

    case WorkLogStatus.Draft:
    default:
      return {
        secondaryText: "Awaiting your submission",
        pill: {
          text: "Draft",
          theme: "neutral",
          icon: "draft"
        }
      };
  }
}
